/* ====================================================================
   48 EAST — TASTE PROFILE MATCHER
   ==================================================================== */

const API = 'https://48e.co/collections/roasted-beans/products.json';

// ---------- STATE ----------
const state = {
  lang: 'en',
  theme: 'night', // 'night' | 'day'
  products: [],
  currentSlide: 0, // 0 = intro, 1..5 = questions, 6 = result
  answers: {}, // qId -> selected option index
  result: null,
};

// ---------- ICONS (inline SVG) ----------
const ICON = {
  espresso: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 8h12v6a4 4 0 01-4 4H9a4 4 0 01-4-4V8z"/><path d="M17 10h2a2 2 0 010 4h-2"/><path d="M8 3v2M11 3v2M14 3v2"/></svg>',
  filter:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 4h12l-2 5H8L6 4z"/><path d="M8 9l-1 11h10l-1-11"/><path d="M10 13v4M14 13v4"/></svg>',
  milk:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M9 2h6v3l2 4v10a2 2 0 01-2 2H9a2 2 0 01-2-2V9l2-4V2z"/><rect x="9" y="12" width="6" height="6" rx="1"/></svg>',
  cold:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 2v20M4.93 6.34l14.14 11.32M4.93 17.66L19.07 6.34"/><path d="M12 5l2 2-2 2-2-2 2-2zM12 17l2 2-2 2-2-2 2-2z"/></svg>',
  chocolate: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="4" y="4" width="16" height="16" rx="2"/><line x1="4" y1="10" x2="20" y2="10"/><line x1="4" y1="16" x2="20" y2="16"/><line x1="10" y1="4" x2="10" y2="20"/><line x1="16" y1="4" x2="16" y2="20"/></svg>',
  fruity:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 22c4 0 7-3 7-7s-3-9-7-9-7 4-7 9 3 7 7 7z"/><path d="M12 6c0-2 1-4 3-4"/><path d="M9 12c0-1 1-2 2-2"/></svg>',
  floral:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="2"/><path d="M12 10c0-3-2-5-2-5s-1 3 0 5"/><path d="M12 14c0 3 2 5 2 5s1-3 0-5"/><path d="M10 12c-3 0-5-2-5-2s3-1 5 0"/><path d="M14 12c3 0 5 2 5 2s-3 1-5 0"/></svg>',
  nutty:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 2c4 2 6 6 6 10s-2 8-6 10c-4-2-6-6-6-10s2-8 6-10z"/><path d="M12 2v20"/></svg>',
  citrus:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="9"/><line x1="12" y1="3" x2="12" y2="21"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="5.6" y1="5.6" x2="18.4" y2="18.4"/><line x1="18.4" y1="5.6" x2="5.6" y2="18.4"/></svg>',
  light:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="3"/><line x1="12" y1="3" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="21"/><line x1="3" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="21" y2="12"/></svg>',
  medium:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="6"/></svg>',
  full:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="9" fill="currentColor" opacity="0.3"/><circle cx="12" cy="12" r="9"/></svg>',
  bright:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="4"/><line x1="12" y1="2" x2="12" y2="5"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="2" y1="12" x2="5" y2="12"/><line x1="19" y1="12" x2="22" y2="12"/><line x1="4.93" y1="4.93" x2="7.05" y2="7.05"/><line x1="16.95" y1="16.95" x2="19.07" y2="19.07"/><line x1="4.93" y1="19.07" x2="7.05" y2="16.95"/><line x1="16.95" y1="7.05" x2="19.07" y2="4.93"/></svg>',
  balanced:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 3v18"/><path d="M5 9l7-3 7 3"/><path d="M5 9l-2 6h4l-2-6z"/><path d="M19 9l-2 6h4l-2-6z"/></svg>',
  smooth:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 12c2-4 6-4 9 0s7 4 9 0"/><path d="M3 7c2-4 6-4 9 0s7 4 9 0"/><path d="M3 17c2-4 6-4 9 0s7 4 9 0"/></svg>',
  budget:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="9"/><path d="M9 9h4a2 2 0 010 4H9M9 9v8M9 13h6"/></svg>',
  mid:       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/></svg>',
  premium:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 7l3-3h8l3 3-7 13L5 7z"/><path d="M8 4l4 6 4-6"/></svg>',
  any:       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="6" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="18" cy="12" r="2"/></svg>',
};

// ---------- QUESTIONS ----------
const QUESTIONS = [
  {
    id: 'brew',
    title: { en: 'How will you brew it?', ar: 'كيف ستحضّر قهوتك؟' },
    options: [
      { icon:'espresso', label:{en:'Espresso',ar:'إسبريسو'}, desc:{en:'Pulled shots, moka pot',ar:'إسبريسو أو موكا بوت'}, score:{tags:['Espresso Coffee'], weight:3} },
      { icon:'filter',   label:{en:'Filter / Pour-over',ar:'فلتر / صبّ يدوي'}, desc:{en:'V60, Chemex, Aeropress',ar:'في٦٠، كيمكس، آيروبرس'}, score:{tags:['Filter Coffee'], weight:3} },
      { icon:'milk',     label:{en:'Milk drinks',ar:'مع الحليب'}, desc:{en:'Latte, cappuccino, flat white',ar:'لاتيه، كابتشينو، فلات وايت'}, score:{tags:['Milk Based','Espresso Coffee'], weight:3} },
      { icon:'cold',     label:{en:'Cold brew',ar:'كولد برو'}, desc:{en:'Slow-steeped, served cold',ar:'تخمير بارد بطيء'}, score:{tags:['Cold Brew Coffee'], weight:3} },
    ],
  },
  {
    id: 'flavor',
    title: { en: 'Which flavor world calls to you?', ar: 'أي عالم نكهة يستهويك؟' },
    options: [
      { icon:'chocolate', label:{en:'Chocolate & cocoa',ar:'شوكولاتة وكاكاو'}, desc:{en:'Dark, comforting, rich',ar:'غنية ومريحة'}, score:{notes:['chocolate','cocoa','cacao','dark chocolate','شوكولاته','كاكاو'], weight:3} },
      { icon:'fruity',    label:{en:'Berries & stone fruit',ar:'توت وفاكهة الحجرية'}, desc:{en:'Bright, juicy, complex',ar:'فاكهية ومنعشة'}, score:{notes:['berry','berries','barries','strawberry','raspberry','plum','peach','figs','stone fruit','توت','خوخ','برقوق'], weight:3, tags:['Fruity']} },
      { icon:'floral',    label:{en:'Floral & tea-like',ar:'زهرية وشاي'}, desc:{en:'Delicate, fragrant',ar:'رقيقة وعطرة'}, score:{notes:['floral','jasmine','rose','honeysuckle','white tea','زهري','ماء الورد'], weight:3, tags:['Floral']} },
      { icon:'nutty',     label:{en:'Nuts & caramel',ar:'مكسرات وكراميل'}, desc:{en:'Toasty, sweet, mellow',ar:'محمصة وحلوة'}, score:{notes:['nut','nuts','almond','hazelnut','nutty','caramel','sugar cane','brown sugar','مكسرات','كراميل','بندق','لوز'], weight:3, tags:['Caramel / Sweet']} },
      { icon:'citrus',    label:{en:'Citrus & bright',ar:'حمضيات ومنعشة'}, desc:{en:'Orange, mandarin, lemon',ar:'برتقال، يوسفي، ليمون'}, score:{notes:['citrus','orange','mandarin','lemon','lime','برتقال','يوسفي','ليمون'], weight:3, tags:['Citrus']} },
    ],
  },
  {
    id: 'character',
    type: 'multiRow',
    title: { en: 'How do you like your cup?', ar: 'كيف تحب فنجانك؟' },
    rows: [
      {
        key: 'body',
        label: { en: 'BODY', ar: 'القوام' },
        weight: 2.5,
        options: [
          { icon:'light',  label:{en:'Light',ar:'خفيف'}, desc:{en:'Tea-like, delicate',ar:'رقيق كالشاي'}, match:[1,2] },
          { icon:'medium', label:{en:'Medium',ar:'متوسط'}, desc:{en:'Versatile',ar:'متوازن'}, match:[3] },
          { icon:'full',   label:{en:'Full',ar:'ثقيل'}, desc:{en:'Velvety, rich',ar:'مخملي وغني'}, match:[4,5] },
        ],
      },
      {
        key: 'acidity',
        label: { en: 'ACIDITY', ar: 'الحموضة' },
        weight: 2.5,
        options: [
          { icon:'smooth', label:{en:'Smooth',ar:'ناعمة'}, desc:{en:'Low, mellow',ar:'قليلة وهادئة'}, match:[1,2] },
          { icon:'balanced', label:{en:'Balanced',ar:'متوازنة'}, desc:{en:'A little of both',ar:'بين هذا وذاك'}, match:[3] },
          { icon:'bright', label:{en:'Bright',ar:'منعشة'}, desc:{en:'Lively, vibrant',ar:'حيوية ومنعشة'}, match:[4,5] },
        ],
      },
    ],
  },
];

// ---------- DATA PARSING ----------
function parseDots(html, labels) {
  // Find a label like "Sweetness:" or "الحلاوة:" and read filled dots (●) before the next 5-dot pattern.
  if (!html) return 0;
  for (const lbl of labels) {
    const re = new RegExp(lbl + '[:\\s]*<\\/strong>([^<]*)', 'i');
    const m = html.match(re);
    if (m) {
      const filled = (m[1].match(/●/g) || []).length;
      if (filled > 0) return Math.min(filled, 5);
    }
  }
  return 0;
}

function parseFlavorNotes(html) {
  if (!html) return [];
  // Try to capture the line after "Flavour Notes:" — English version only for matching.
  const m = html.match(/Flavour\s+Notes:?\s*<\/strong>([^<]+)/i);
  if (m) {
    // Decode HTML entities (&amp; → &), then split on commas, ampersands, bullets
    const decoded = m[1].replace(/&amp;/g, ' ').replace(/&[a-z]+;/g, ' ');
    return decoded.split(/[,،&\u2022]/).map(s => s.trim().toLowerCase()).filter(s => s && s.length > 1);
  }
  return [];
}

function parseOrigin(title) {
  // "Yirga Red | Ethiopia" -> "Ethiopia"
  const parts = title.split('|').map(s => s.trim());
  return parts.length > 1 ? parts[parts.length - 1] : '';
}

function getProductName(title) {
  return title.split('|')[0].trim();
}

function getArabicName(html) {
  if (!html) return '';
  // Arabic name is typically in the first <strong> or <b> tag at the top.
  const m = html.match(/<(?:strong|b)>([^<]*[\u0600-\u06FF][^<]*)<\/(?:strong|b)>/);
  return m ? m[1].trim() : '';
}

function enrich(product) {
  const html = product.body_html || '';
  const en = {
    name: getProductName(product.title),
    origin: parseOrigin(product.title),
    sweetness: parseDots(html, ['Sweetness']),
    body: parseDots(html, ['Body','Aroma']),  // some products use Aroma instead of Body
    acidity: parseDots(html, ['Acidity']),
    notes: parseFlavorNotes(html),
  };
  // body/aroma can both exist – take whichever scored
  if (!en.body) en.body = parseDots(html, ['Aroma']);
  const price = parseFloat(product.variants?.[0]?.price || '0');
  const available = product.variants?.[0]?.available !== false;
  return {
    id: product.id,
    handle: product.handle,
    title: product.title,
    nameEn: en.name,
    nameAr: getArabicName(html),
    origin: en.origin,
    tags: product.tags || [],
    sweetness: en.sweetness || 3,
    body: en.body || 3,
    acidity: en.acidity || 3,
    notes: en.notes,
    price,
    available,
    image: product.images?.[0]?.src || '',
    url: `https://48e.co/products/${product.handle}`,
  };
}

// ---------- SCORING ----------
function scoreProduct(product, answers) {
  let score = 0;
  let possible = 0;

  QUESTIONS.forEach(q => {
    const ans = answers[q.id];
    if (ans == null) return;

    // ---- multiRow questions (e.g. body + acidity on two rows) ----
    if (q.type === 'multiRow') {
      q.rows.forEach(row => {
        const idx = ans[row.key];
        if (idx == null) return;
        const w = row.weight || 1;
        possible += w;
        const target = row.options[idx].match; // array of matching dot values
        const actual = product[row.key];        // product.body or product.acidity
        if (target.includes(actual)) score += w;
        else if (target.some(v => Math.abs(v - actual) === 1)) score += w * 0.4;
      });
      return;
    }

    // ---- single-select questions ----
    const opt = q.options[ans];
    const s = opt.score;
    const w = s.weight || 1;
    possible += w;

    // Tag match
    if (s.tags && s.tags.length) {
      const hit = s.tags.some(t => product.tags.includes(t));
      if (hit) score += w;
    }

    // Note match
    if (s.notes && s.notes.length) {
      const hits = s.notes.filter(n =>
        product.notes.some(pn => pn.includes(n)) ||
        (product.title + ' ' + (product.tags||[]).join(' ')).toLowerCase().includes(n)
      ).length;
      if (hits > 0) score += w * Math.min(1, hits / 1.5);
    }

    // Body match
    if (s.body && s.body.length) {
      if (s.body.includes(product.body)) score += w;
      else if (s.body.some(b => Math.abs(b - product.body) === 1)) score += w * 0.4;
    }

    // Acidity match
    if (s.acidity && s.acidity.length) {
      if (s.acidity.includes(product.acidity)) score += w;
      else if (s.acidity.some(a => Math.abs(a - product.acidity) === 1)) score += w * 0.4;
    }

    // Price match
    if (s.priceRange) {
      const [lo, hi] = s.priceRange;
      if (product.price >= lo && product.price <= hi) score += w;
    }
  });

  // Availability boost — strongly prefer in-stock items
  if (!product.available) score *= 0.5;

  // Slight randomness to break ties for repeat takers (very small)
  score += Math.random() * 0.05;

  return possible > 0 ? score / possible : 0;
}

// ---------- API FETCH ----------
async function loadProducts() {
  try {
    const res = await fetch(API);
    if (!res.ok) throw new Error('HTTP ' + res.status);
    const data = await res.json();
    const enriched = (data.products || [])
      .map(enrich)
      .filter(p => p.price > 0); // skip anything without a real price
    state.products = enriched;
    document.getElementById('catalog-count').textContent = `${enriched.length} ${state.lang === 'ar' ? 'حبة' : 'beans'}`;
    return enriched;
  } catch (e) {
    console.error('Product fetch failed:', e);
    const err = document.getElementById('intro-error');
    err.textContent = state.lang === 'ar'
      ? '⚠ تعذّر تحميل قائمة المنتجات. تأكد من الاتصال بالإنترنت.'
      : '⚠ Could not load the live product catalog. Check your connection.';
    err.classList.add('show');
    return [];
  }
}

// ---------- RENDER ----------
function renderQuestions() {
  const container = document.getElementById('questions-container');
  container.innerHTML = QUESTIONS.map((q, qi) => {
    const isLast = qi === QUESTIONS.length - 1;
    const nav = `
      <div class="nav-row">
        <button class="btn btn-ghost" data-nav="back">
          <span class="en-only">← Back</span>
          <span class="ar-only">→ رجوع</span>
        </button>
        <button class="btn btn-primary" data-nav="next" disabled>
          <span class="en-only">${isLast ? 'See result' : 'Next'}</span>
          <span class="ar-only">${isLast ? 'النتيجة' : 'التالي'}</span>
          <span class="btn-arrow">→</span>
        </button>
      </div>`;

    const head = `
      <div class="qnum">
        <span class="en-only">QUESTION ${qi+1} OF ${QUESTIONS.length}</span>
        <span class="ar-only">سؤال ${qi+1} من ${QUESTIONS.length}</span>
      </div>
      <h2 class="qtitle en-only">${q.title.en}</h2>
      <h2 class="qtitle ar-only">${q.title.ar}</h2>`;

    // ---- multiRow question (two axes on one screen) ----
    if (q.type === 'multiRow') {
      const rows = q.rows.map(row => `
        <div class="axis-row" data-row="${row.key}">
          <div class="axis-label en-only">${row.label.en}</div>
          <div class="axis-label ar-only">${row.label.ar}</div>
          <div class="axis-options" role="radiogroup">
            ${row.options.map((opt, oi) => `
              <button class="chip" data-q="${q.id}" data-row="${row.key}" data-i="${oi}" role="radio" aria-checked="false">
                <div class="chip-icon">${ICON[opt.icon] || ICON.any}</div>
                <div class="chip-label en-only">${opt.label.en}</div>
                <div class="chip-label ar-only">${opt.label.ar}</div>
                <div class="chip-desc en-only">${opt.desc.en}</div>
                <div class="chip-desc ar-only">${opt.desc.ar}</div>
              </button>
            `).join('')}
          </div>
        </div>
      `).join('');
      return `
        <section class="slide" data-slide="q${qi+1}" data-qid="${q.id}" data-type="multiRow">
          ${head}
          <div class="axes">${rows}</div>
          ${nav}
        </section>`;
    }

    // ---- single-select question ----
    return `
      <section class="slide" data-slide="q${qi+1}" data-qid="${q.id}">
        ${head}
        <div class="options" role="radiogroup">
          ${q.options.map((opt, oi) => `
            <button class="option" data-q="${q.id}" data-i="${oi}" role="radio" aria-checked="false">
              <div class="option-icon">${ICON[opt.icon] || ICON.any}</div>
              <div class="option-body">
                <div class="option-label en-only">${opt.label.en}</div>
                <div class="option-label ar-only">${opt.label.ar}</div>
                <div class="option-desc en-only">${opt.desc.en}</div>
                <div class="option-desc ar-only">${opt.desc.ar}</div>
              </div>
            </button>
          `).join('')}
        </div>
        ${nav}
      </section>`;
  }).join('');

  // wire single-select option clicks
  container.querySelectorAll('.option').forEach(btn => {
    btn.addEventListener('click', () => {
      const q = btn.dataset.q;
      const i = parseInt(btn.dataset.i, 10);
      state.answers[q] = i;
      btn.parentElement.querySelectorAll('.option').forEach(b => {
        b.classList.remove('selected');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('selected');
      btn.setAttribute('aria-checked', 'true');
      const next = btn.closest('.slide').querySelector('[data-nav="next"]');
      next.disabled = false;
    });
  });

  // wire multiRow chip clicks
  container.querySelectorAll('.chip').forEach(btn => {
    btn.addEventListener('click', () => {
      const q = btn.dataset.q;
      const rowKey = btn.dataset.row;
      const i = parseInt(btn.dataset.i, 10);
      if (typeof state.answers[q] !== 'object' || state.answers[q] === null) {
        state.answers[q] = {};
      }
      state.answers[q][rowKey] = i;
      // mark selection within this row only
      const row = btn.closest('.axis-row');
      row.querySelectorAll('.chip').forEach(b => {
        b.classList.remove('selected');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('selected');
      btn.setAttribute('aria-checked', 'true');
      // enable next only when all rows in this question are answered
      const slide = btn.closest('.slide');
      const qDef = QUESTIONS.find(x => x.id === q);
      const ans = state.answers[q];
      const allAnswered = qDef.rows.every(r => ans[r.key] != null);
      slide.querySelector('[data-nav="next"]').disabled = !allAnswered;
    });
  });

  // nav buttons
  container.querySelectorAll('[data-nav="next"]').forEach(b => b.addEventListener('click', goNext));
  container.querySelectorAll('[data-nav="back"]').forEach(b => b.addEventListener('click', goBack));
}

function renderProgress() {
  const el = document.getElementById('progress');
  el.innerHTML = QUESTIONS.map((_, i) => `<div class="progress-step" data-i="${i}"></div>`).join('');
}

function updateProgress() {
  const el = document.getElementById('progress');
  if (state.currentSlide === 0) {
    el.classList.remove('show');
    return;
  }
  el.classList.add('show');
  el.querySelectorAll('.progress-step').forEach((step, i) => {
    step.classList.remove('done','active');
    if (i < state.currentSlide - 1) step.classList.add('done');
    else if (i === state.currentSlide - 1) step.classList.add('active');
  });
}

function showSlide(idx) {
  state.currentSlide = idx;
  document.querySelectorAll('.slide').forEach(s => s.classList.remove('active'));
  document.getElementById('result').classList.remove('active');
  document.getElementById('loading').classList.remove('active');

  if (idx === 0) {
    document.querySelector('[data-slide="intro"]').classList.add('active');
  } else if (idx >= 1 && idx <= QUESTIONS.length) {
    document.querySelector(`[data-slide="q${idx}"]`).classList.add('active');
  }
  updateProgress();
  // scroll into view on mobile
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function goNext() {
  if (state.currentSlide < QUESTIONS.length) {
    showSlide(state.currentSlide + 1);
  } else {
    finish();
  }
}

function goBack() {
  if (state.currentSlide > 1) {
    showSlide(state.currentSlide - 1);
    // Re-select previous answer visually
    const slide = document.querySelector(`[data-slide="q${state.currentSlide}"]`);
    const qid = slide.dataset.qid;
    const prev = state.answers[qid];
    if (prev == null) return;

    if (slide.dataset.type === 'multiRow' && typeof prev === 'object') {
      // restore each row's selected chip
      const qDef = QUESTIONS.find(x => x.id === qid);
      qDef.rows.forEach(row => {
        const idx = prev[row.key];
        if (idx == null) return;
        const rowEl = slide.querySelector(`.axis-row[data-row="${row.key}"]`);
        const chip = rowEl.querySelector(`.chip[data-i="${idx}"]`);
        if (chip) {
          rowEl.querySelectorAll('.chip').forEach(b => b.classList.remove('selected'));
          chip.classList.add('selected');
        }
      });
      const allAnswered = qDef.rows.every(r => prev[r.key] != null);
      slide.querySelector('[data-nav="next"]').disabled = !allAnswered;
    } else {
      const opt = slide.querySelector(`.option[data-i="${prev}"]`);
      if (opt) {
        slide.querySelectorAll('.option').forEach(b => b.classList.remove('selected'));
        opt.classList.add('selected');
        slide.querySelector('[data-nav="next"]').disabled = false;
      }
    }
  }
}

async function finish() {
  // Hide everything, show loading
  document.querySelectorAll('.slide').forEach(s => s.classList.remove('active'));
  document.getElementById('progress').classList.remove('show');
  document.getElementById('loading').classList.add('active');

  // If products didn't load earlier, try again
  if (!state.products.length) {
    await loadProducts();
  }

  // Score
  const scored = state.products.map(p => ({
    product: p,
    score: scoreProduct(p, state.answers),
  })).sort((a, b) => b.score - a.score);

  // Filter out Mystery Brew from primary recommendations (its concept is "unknown" — bad as a match)
  const visible = scored.filter(s => !/mystery\s*brew/i.test(s.product.title));

  state.result = visible[0];
  const runners = pickRunners(visible);

  // Small delay so the loading feels intentional
  await new Promise(r => setTimeout(r, 700));

  renderResult(state.result, runners);
}

// Choose 2-3 runners-up by match strength.
// A bean qualifies as a "strong" runner only if it is both:
//   (a) close to the top match (>= 70% of its score), AND
//   (b) a genuinely good fit on its own (absolute score >= 0.5).
// Show 3 only when at least 3 strong runners exist; otherwise show 2.
function pickRunners(visible) {
  const topScore = visible[0] ? visible[0].score : 0;
  const pool = visible.slice(1); // exclude the top match itself
  const strong = pool.filter(r =>
    topScore > 0 && r.score >= topScore * 0.70 && r.score >= 0.62
  );
  let count = strong.length >= 3 ? 3 : 2;
  count = Math.min(count, pool.length); // don't exceed what's available
  return pool.slice(0, count);
}

function renderResult(top, runners) {
  if (!top) {
    document.getElementById('loading').classList.remove('active');
    const err = document.getElementById('intro-error');
    err.textContent = state.lang === 'ar' ? 'تعذّر إيجاد قهوة مطابقة. جرّب مرة أخرى.' : 'No match found. Try again.';
    err.classList.add('show');
    showSlide(0);
    return;
  }

  const p = top.product;
  const matchPct = Math.max(72, Math.min(99, Math.round(top.score * 100)));

  // Update result content
  const imgWrap = document.getElementById('result-img-wrap');
  imgWrap.innerHTML = `
    <div class="result-match-badge en-only">${matchPct}% MATCH</div>
    <div class="result-match-badge ar-only">${toArabicDigits(matchPct)}٪ تطابق</div>
    ${p.image
      ? `<img src="${p.image}" alt="${p.nameEn}" onerror="this.outerHTML='<div class=\\'img-placeholder\\'>${p.nameEn}</div>'">`
      : `<div class="img-placeholder">${p.nameEn}</div>`}
  `;

  document.getElementById('result-name').innerHTML = state.lang === 'ar'
    ? (p.nameAr || p.nameEn)
    : p.nameEn;

  const originText = p.origin
    ? (state.lang === 'ar' ? `قهوة مختصة • ${p.origin}` : `${p.origin.toUpperCase()} • SPECIALTY`)
    : (state.lang === 'ar' ? 'قهوة مختصة' : 'SPECIALTY BLEND');
  document.getElementById('result-origin').textContent = originText;

  // attributes
  const attrs = [
    { label_en:'Sweetness', label_ar:'الحلاوة', val:p.sweetness },
    { label_en:'Body',      label_ar:'القوام',  val:p.body },
    { label_en:'Acidity',   label_ar:'الحموضة', val:p.acidity },
  ];
  document.getElementById('result-attributes').innerHTML = attrs.map(a => `
    <div class="attr-row">
      <span class="attr-label en-only">${a.label_en}</span>
      <span class="attr-label ar-only">${a.label_ar}</span>
      <div class="attr-dots">
        ${[1,2,3,4,5].map(n => `<span class="dot ${n <= a.val ? 'filled' : ''}"></span>`).join('')}
      </div>
    </div>
  `).join('');

  // notes
  document.getElementById('result-notes').innerHTML = p.notes
    .slice(0, 6)
    .map(n => `<span class="note">${capitalize(n)}</span>`)
    .join('');

  // price
  const priceEl = document.getElementById('result-price');
  const weight = '250g';
  priceEl.innerHTML = state.lang === 'ar'
    ? `${p.price.toFixed(3)} <small>د.ك / ٢٥٠ جم</small>`
    : `${p.price.toFixed(3)} <small>KWD / 250g</small>`;

  // link
  document.getElementById('result-link').href = p.url;

  // runners
  document.getElementById('runners-grid').innerHTML = runners.map(r => `
    <a class="runner-card" href="${r.product.url}" target="_blank" rel="noopener">
      <div class="runner-name">${state.lang === 'ar' ? (r.product.nameAr || r.product.nameEn) : r.product.nameEn}</div>
      <div class="runner-price">${r.product.price.toFixed(3)} ${state.lang === 'ar' ? 'د.ك' : 'KWD'}</div>
    </a>
  `).join('');

  // show result
  document.getElementById('loading').classList.remove('active');
  document.getElementById('result').classList.add('active');
}

function toArabicDigits(n) {
  return String(n).replace(/\d/g, d => '٠١٢٣٤٥٦٧٨٩'[d]);
}
function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// ---------- LANG ----------
function setLang(lang) {
  state.lang = lang;
  const body = document.body;
  body.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
  body.setAttribute('lang', lang);
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';

  document.querySelectorAll('.lang-toggle button').forEach(b => {
    b.classList.toggle('active', b.dataset.lang === lang);
  });

  // Update catalog count
  if (state.products.length) {
    document.getElementById('catalog-count').textContent =
      `${state.products.length} ${lang === 'ar' ? 'حبة' : 'beans'}`;
  }

  // If we're on a result, re-render it (so name swaps language)
  if (state.result && document.getElementById('result').classList.contains('active')) {
    const scored = state.products.map(p => ({ product: p, score: scoreProduct(p, state.answers) }))
      .sort((a, b) => b.score - a.score);
    const visible = scored.filter(s => !/mystery\s*brew/i.test(s.product.title));
    renderResult(visible[0], pickRunners(visible));
  }
}

// ---------- THEME ----------
function setTheme(theme) {
  state.theme = theme;
  document.body.classList.toggle('day', theme === 'day');
  // Keep the browser UI (address bar) in sync on mobile
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', theme === 'day' ? '#F4F1EC' : '#000000');
}

function toggleTheme() {
  setTheme(state.theme === 'night' ? 'day' : 'night');
}

// ---------- BOOT ----------
function init() {
  renderProgress();
  renderQuestions();

  document.getElementById('btn-start').addEventListener('click', () => showSlide(1));
  document.getElementById('btn-restart').addEventListener('click', () => {
    state.answers = {};
    state.result = null;
    document.querySelectorAll('.option').forEach(o => o.classList.remove('selected'));
    document.querySelectorAll('[data-nav="next"]').forEach(b => b.disabled = true);
    document.getElementById('result').classList.remove('active');
    showSlide(0);
  });
  document.getElementById('btn-tell-more').addEventListener('click', () => {
    if (!state.result) return;
    const p = state.result.product;
    const chosen = QUESTIONS.map(q => {
      const ans = state.answers[q.id];
      if (ans == null) return null;
      if (q.type === 'multiRow') {
        // collect each row's chosen label, e.g. "Light · Bright"
        const parts = q.rows.map(row => {
          const idx = ans[row.key];
          return idx != null ? row.options[idx].label[state.lang] : null;
        }).filter(Boolean);
        return parts.join(state.lang === 'ar' ? ' · ' : ' · ');
      }
      return q.options[ans].label[state.lang];
    }).filter(Boolean);
    const msg = state.lang === 'ar'
      ? `اخترنا ${p.nameAr || p.nameEn} بناءً على إجاباتك: ${chosen.join('، ')}.\n\nبروفايل النكهة:\n• الحلاوة: ${'●'.repeat(p.sweetness)}${'○'.repeat(5-p.sweetness)}\n• القوام: ${'●'.repeat(p.body)}${'○'.repeat(5-p.body)}\n• الحموضة: ${'●'.repeat(p.acidity)}${'○'.repeat(5-p.acidity)}\n\nالنكهات: ${p.notes.join('، ')}`
      : `We picked ${p.nameEn} based on your choices: ${chosen.join(', ')}.\n\nFlavor profile:\n• Sweetness: ${'●'.repeat(p.sweetness)}${'○'.repeat(5-p.sweetness)}\n• Body: ${'●'.repeat(p.body)}${'○'.repeat(5-p.body)}\n• Acidity: ${'●'.repeat(p.acidity)}${'○'.repeat(5-p.acidity)}\n\nNotes: ${p.notes.join(', ')}`;
    alert(msg);
  });

  document.querySelectorAll('.lang-toggle button').forEach(b => {
    b.addEventListener('click', () => setLang(b.dataset.lang));
  });

  // Theme toggle
  document.getElementById('theme-toggle').addEventListener('click', toggleTheme);
  setTheme('night'); // default

  // Preload products in background
  loadProducts();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}